import React,{useState} from 'react';
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  ResponsiveContainer,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { LineChartTooltip } from "../../ProductInventory/InventoryCharts/LineChartTooltip";


const StoreManagerChart = ({statsLoading}) => {
      const [activeTab, setActiveTab] = useState("stock_request");
      const [period, setPeriod] = useState("12months");
      // Mock data for the chart - transforms based on period and tab
      const getChartData = () => {
        const stockRequestData = {
          "12months": [
            { name: "Jan", value: 35000 },
            { name: "Feb", value: 38000 },
            { name: "Mar", value: 32000 },
            { name: "Apr", value: 41000 },
            { name: "May", value: 36000 },
            { name: "Jun", value: 44000 },
            { name: "Jul", value: 39000 },
            { name: "Aug", value: 42000 },
            { name: "Sep", value: 40000 },
            { name: "Oct", value: 45000 },
            { name: "Nov", value: 43000 },
            { name: "Dec", value: 47000 }
          ],
          "6months": [
            { name: "Jul", value: 39000 },
            { name: "Aug", value: 42000 },
            { name: "Sep", value: 40000 },
            { name: "Oct", value: 45000 },
            { name: "Nov", value: 43000 },
            { name: "Dec", value: 47000 }
          ],
          "3months": [
            { name: "Oct", value: 45000 },
            { name: "Nov", value: 43000 },
            { name: "Dec", value: 47000 }
          ]
        };
    
        const deliveriesData = {
          "12months": [
            { name: "Jan", value: 28000 },
            { name: "Feb", value: 31000 },
            { name: "Mar", value: 29000 },
            { name: "Apr", value: 35000 },
            { name: "May", value: 32000 },
            { name: "Jun", value: 38000 },
            { name: "Jul", value: 34000 },
            { name: "Aug", value: 37000 },
            { name: "Sep", value: 36000 },
            { name: "Oct", value: 40000 },
            { name: "Nov", value: 38000 },
            { name: "Dec", value: 42000 }
          ],
          "6months": [
            { name: "Jul", value: 34000 },
            { name: "Aug", value: 37000 },
            { name: "Sep", value: 36000 },
            { name: "Oct", value: 40000 },
            { name: "Nov", value: 38000 },
            { name: "Dec", value: 42000 }
          ],
          "3months": [
            { name: "Oct", value: 40000 },
            { name: "Nov", value: 38000 },
            { name: "Dec", value: 42000 }
          ]
        };
    
        return activeTab === "stock_request" ? stockRequestData[period] : deliveriesData[period];
      };
    
      const chartData = getChartData();
    
      // Get total value based on active tab
      const getTotalValue = () => {
        if (activeTab === "stock_request") {
          return "488,587";
        } else {
          return "356,124";
        }
      };
    
      const tabs = [
        { id: "stock_request", label: "Stock Request" },
        { id: "deliveries", label: "Deliveries" },
      ];

    return (  
           <div className="bg-white rounded-lg border border-[#E1E6E1] p-6">
              {/* Tab Navigation - Using StoreStockChart Pattern */}
              <div className="flex items-center border border-[#E1E6E1] bg-[#F6F7F6] rounded-lg overflow-hidden w-full mb-6">
                {tabs.map((tab) => (
                  <button
                    key={tab.id}
                    onClick={() => setActiveTab(tab.id)}
                    className={`px-4 py-2 text-sm flex-1 font-semibold ${
                      activeTab === tab.id
                        ? "bg-white text-[#161D17]"
                        : "text-[#5F6D60]"
                    } rounded-lg transition`}
                  >
                    {tab.label}
                  </button>
                ))}
              </div>
        
              {/* Total Display */}
              <div className="mb-6 flex items-center justify-between">
                <div>
                  <p className="text-[#5F6D60] text-sm font-semibold">
                    Total {activeTab === "stock_request" ? "Request" : "Deliveries"}
                  </p>
                  <p className="text-[#344335] font-semibold text-2xl mt-1">
                    {statsLoading ? "..." : getTotalValue()}
                  </p>
                </div>
                <div className="">
                  <select
                    value={period}
                    onChange={(e) => setPeriod(e.target.value)}
                    className="text-sm font-semibold text-[#5F6D60] focus:outline-none focus:ring-0"
                  >
                    <option value="12months">12 Months</option>
                    <option value="6months">6 Months</option>
                    <option value="3months">3 Months</option>
                  </select>
                </div>
              </div>
              
              {/* Chart Container */}
              <div className="h-80">
                {statsLoading ? (
                  <div className="flex items-center justify-center h-full">
                    <div className="animate-pulse">
                      <div className="flex space-x-2">
                        {[...Array(10)].map((_, index) => (
                          <div
                            key={index}
                            className="bg-gray-200 rounded"
                            style={{
                              width: "24px",
                              height: `${Math.random() * 100 + 50}px`,
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  </div>
                ) : chartData.length > 0 ? (
                  <div style={{ width: "100%", height: "100%" }}>
                    <ResponsiveContainer>
                      <AreaChart
                        data={chartData}
                        margin={{ top: 10, right: 10, left: 0, bottom: 0 }}
                      >
                        <defs>
                          <linearGradient id="stockRequestGradient" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#EEF6EF" stopOpacity={1} />
                            <stop offset="100%" stopColor="#F8FCF9" stopOpacity={0.5} />
                          </linearGradient>
                          <linearGradient id="deliveriesGradient" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#EEF6EF" stopOpacity={1} />
                            <stop offset="100%" stopColor="#F8FCF9" stopOpacity={0.5} />
                          </linearGradient>
                        </defs>
                        <CartesianGrid
                          stroke="#5F6D60"
                          strokeOpacity={0.1}
                          vertical={false}
                        />
                        <XAxis 
                          dataKey="name" 
                          fontSize={12}
                          axisLine={false}
                          tickLine={false}
                          tick={{ fill: '#5F6D60' }}
                        />
                        <YAxis hide />
                        <Tooltip content={<LineChartTooltip />} />
                        <Area
                          type="monotone"
                          dataKey="value"
                          stroke="#2B8C34"
                          fill={activeTab === "stock_request" ? "url(#stockRequestGradient)" : "url(#deliveriesGradient)"}
                          fillOpacity={1}
                          strokeWidth={2}
                          dot={false}
                        />
                      </AreaChart>
                    </ResponsiveContainer>
                  </div>
                ) : (
                  <div className="flex items-center justify-center h-full">
                    <div className="text-center">
                      <div className="w-16 h-16 mx-auto mb-4 bg-[#F6F7F6] rounded-full flex items-center justify-center">
                        <svg 
                          className="w-8 h-8 text-[#5F6D60]" 
                          fill="none" 
                          stroke="currentColor" 
                          viewBox="0 0 24 24"
                        >
                          <path 
                            strokeLinecap="round" 
                            strokeLinejoin="round" 
                            strokeWidth={2} 
                            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" 
                          />
                        </svg>
                      </div>
                      <p className="text-[#5F6D60] text-sm">
                        No {activeTab === "stock_request" ? "stock request" : "deliveries"} data available
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
    );
}
 
export default StoreManagerChart;